import * as yup from 'yup';

export const schema = yup.object().shape({
  title: yup.string().required('O título é obrigatório.'),
  event_date: yup.string().nullable().required('A data é obrigatória.'),
});
